module.exports = __webpack_public_path__ + "img/AnnotatedStatCard.57bd9617.jpg";